// src/components/Footer.js
import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2024 R&DC Academy. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}

export default Footer;